import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import grayLogo from '../../../../assets/gray-logo.svg?url';
import Button from '../Button';
import Modal from '../Modal';

import styles from '../../../styles/views/components/OnboardingModal.module.scss';

export default function OnboardingModal({
  isShown,
  closeModal,
  content,
  details,
}) {
  const { pathname } = useLocation();

  const [selectedItem, setSelectedItem] = useState(content.find(item => item?.correspondingRoutes.includes(pathname)) || content[0]);
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);
  const [data, setData] = useState(null);

  const updateContentArray = (index) => {
    const newСheckedArr = content.slice(0, index).map(item => (
      { ...item, isChecked: true }
    ));
    const newUncheckedArr = content.slice(index, content.length).map(item => (
      { ...item, isChecked: false }
    ));
    setData([...newСheckedArr, ...newUncheckedArr]);
  };

  useEffect(() => {
    if (!data) setData(content);
    setSelectedItemIndex(selectedItem.id);
  }, [selectedItem, data, content]);

  useEffect(() => {
    setSelectedItemIndex(selectedItem.id);
    updateContentArray(selectedItem.id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectNavItem = (index) => {
    setSelectedItem(content[index]);
    if (index < selectedItemIndex) setSelectedItemIndex(index - 1);
    if (index > selectedItemIndex) setSelectedItemIndex(index + 1);
    updateContentArray(index);
  };

  const onPrevItemClick = (index) => {
    setSelectedItem(content[index - 1]);
    setData(data.map((item, i) => (i === index - 1 ? { ...item, isChecked: false } : item)));
  };

  const onNextItemClick = (index) => {
    setSelectedItem(content[index + 1]);
    setData(data.map((item, i) => (i === index ? { ...item, isChecked: true } : item)));
  };

  const onCompleteClick = () => {
    closeModal();
    setSelectedItem(content[0]);
    setData(content);
  };

  return (
    <Modal
      isShown={isShown}
      onClose={closeModal}
      modalExtraClass={styles.modal}
      wrapperExtraStyles={{ paddingTop: '9vh', alignItems: 'flex-start', zIndex: 3000 }}
    >
      <div className={styles.contentBlock}>
        <div className={styles.sidebar}>
          <div className={styles.logo}>
            <img src={grayLogo} alt="Logo" />
            {details && <span className={styles.details}>{details}</span>}
          </div>
          <div className={styles.sidebarItems}>{data && data.map((item, i) => (
            <div key={item.id} className={styles.sidebarItem} onClick={() => selectNavItem(i)}>
              <span className={[styles.itemNumber, selectedItemIndex === i && styles.active, item.isChecked && styles.isChecked].join(' ')}>{i + 1}</span>
              <span className={styles.itemTitle}>{item.navTitle}</span>
              {(i !== data.length - 1) ? (<div className={styles.verticalLine} />) : null}
            </div>
          ))}
          </div>
        </div>
        <div className={styles.content}>
          <h2 className={styles.heading}>{selectedItem.title}</h2>
          <hr className={styles.hrLine} />
          <div className={styles.linkContent}>
            {selectedItem.image && <img src={selectedItem.image} alt="" />}
            <div>
              <span dangerouslySetInnerHTML={{ __html: selectedItem.text }} />
              {selectedItem.videoLinkText ? <a href={selectedItem.videoHref}>{selectedItem.videoLinkText}</a> : null}
              {selectedItem.email ? <a href={`mailto:${selectedItem.email}`}>{selectedItem.email}</a> : null}
            </div>
          </div>
          <div className={styles.actions}>
            {selectedItemIndex > 0 && (
            <Button
              onClick={() => onPrevItemClick(selectedItemIndex)}
              value={t('button.back', { ns: i18next.Namespace.COMMON })}
              variant="secondary"
              color="red"
              extraStyles={{ marginRight: '8px' }}
              name="secondaryAction"
            />
            )}
            {selectedItemIndex < content.length - 1 && (
            <Button
              onClick={() => onNextItemClick(selectedItemIndex)}
              value={t('button.next', { ns: i18next.Namespace.COMMON })}
              variant="primary"
              color="red"
              name="primaryAction"
            />
            )
                  }
            {selectedItemIndex === content.length - 1 && (
            <Button
              onClick={onCompleteClick}
              value={t('button.complete', { ns: i18next.Namespace.COMMON })}
              variant="primary"
              color="red"
              name="completeBtnAction"
            />
            )
                  }
          </div>
        </div>
      </div>
    </Modal>
  );
}

OnboardingModal.propTypes = {
  isShown: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([null])]),
  closeModal: PropTypes.func.isRequired,
  content: PropTypes.instanceOf(Array).isRequired,
  details: PropTypes.string,
};

OnboardingModal.defaultProps = {
  isShown: false,
  details: '',
};
